module.exports = __webpack_public_path__ + "img/four3Blue.00f4112e.jpg";